<template>
  <div class="image" :style="{ backgroundImage: 'url(' + image + ')' }">
      <div class="content">
        <div class="space"></div>
        <transition name="slide-fade-1"><h1 v-if="visible" style="margin-bottom: 0;">Ingénierie <span>&</span></h1></transition>
        <transition name="slide-fade-2"><h1 v-if="visible" style="margin-top: 0;">systèmes</h1></transition>
        <transition name="slide-fade-3"><p v-if="visible">Faire du talent individuel notre force collective.</p></transition>
        <transition name="slide-fade-4"><p v-if="visible"></p></transition>
        <transition name="slide-fade-5"><p v-if="visible"></p></transition>
        <div class="button-section">
          <transition name="slide-fade-6"><button class="white" v-if="visible" @click="changeTo('societe')">En savoir plus</button></transition>
          <transition name="slide-fade-7"><button class="blue" v-if="visible" @click="changeTo('contact')">Contact</button></transition>
        </div>
      </div>
  </div>
</template>

<script>
    import {menuBus} from "../../main";

    export default {
      data() {
          return {
              image: this.imageName,
              visible: false,
          }
      },
      props: [
          'imageName'
      ],
      created() {
          let vm = this;
          setTimeout(function() {
              vm.visible = true;
          }, 200);
      },
      methods: {
          changeTo(pageName) {
              menuBus.$emit('changePage', pageName);
          },
      },
      mounted() {
          menuBus.$on('changePage', (pageName, idName) => {
              this.menuShowed = false;
          });
      }
  }
</script>

<style scoped>
  .image {
    background-size: cover;
    z-index: 10;
    height: 100%;
    width: 100%;

    position: absolute;
    top: 0;
    left: 0;
  }

  .content {
    position: absolute;
    left: 150px;
    top: 50%;
    transform: translateY(-50%);
    width: calc(100% - 150px);
    text-align: left;
  }
  p {
    color: white;
    text-align: left;
    font-weight: 300;
    margin: 0;
    font-size: 28px;
    max-width: 80%;
  }
  h1 {
    color: white;
    font-size: 80px;
    text-transform: uppercase;
    font-weight: 900;
    width: 500px;
    text-align: left;
    margin: 20px 0;
  }
  span {
    color: #9fa8bd;
  }

  .button-section {
    margin: 30px 0;
  }
  .button-section button {
    padding: 20px 30px;
    text-transform: uppercase;
    border: none;
    font-weight: bolder;
    margin-right: 25px;
    font-size: 15px;
    cursor: pointer;
  }
  button.white {
    background-color: white;
    color: #162139;
  }
  button.blue {
    background-color: #162139;
    color: white;
  }

  .space {
    height: 200px;
  }

  /* Tablet */
  @media only screen and (max-width: 800px) {
    .content {
      width: calc(100% - 60px);
      left: 30px;
    }
    h1 {
      font-size: 60px;
      text-transform: capitalize;
      width: 100%;
    }
    p {
      font-size: 25px;
      font-weight: normal;
      width: 100%;
      max-width: none;
    }
    .space {
      height: 100px;
    }
  }

  /* Mobile */
  @media (max-width: 500px) {
    .space {
      height: 100px;
    }
    .content {
      width: calc(100% - 60px);
      left: 30px;
    }
    h1 {
      font-size: 50px;
      text-transform: capitalize;
      width: 100%;
    }
    p {
      font-size: 20px;
      font-weight: normal;
      width: 100%;
      max-width: none;
    }
    .button-section {
      width: 100%;

      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
    button {
      margin: 0 !important;
      padding: 20px 10px !important;
      width: calc(50% - 20px);
      font-size: 13px !important;
    }
  }

  .slide-fade-1-enter-active {
    transition: all .5s ease;
  }
  .slide-fade-1-leave-active {
    transition: all .5s;
  }
  .slide-fade-1-enter, .slide-fade-1-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    margin-left: 50px;
    opacity: 0;
  }

  .slide-fade-2-enter-active {
    transition: all .75s ease;
  }
  .slide-fade-2-leave-active {
    transition: all .75s;
  }
  .slide-fade-2-enter, .slide-fade-2-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    margin-left: 50px;
    opacity: 0;
  }

  .slide-fade-3-enter-active {
    transition: all 1s ease;
  }
  .slide-fade-3-leave-active {
    transition: all 1s;
  }
  .slide-fade-3-enter, .slide-fade-3-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    margin-left: 50px;
    opacity: 0;
  }

  .slide-fade-4-enter-active {
    transition: all 1.25s ease;
  }
  .slide-fade-4-leave-active {
    transition: all 1.25s;
  }
  .slide-fade-4-enter, .slide-fade-4-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    margin-left: 50px;
    opacity: 0;
  }

  .slide-fade-5-enter-active {
    transition: all 1.5s ease;
  }
  .slide-fade-5-leave-active {
    transition: all 1.5s;
  }
  .slide-fade-5-enter, .slide-fade-5-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    margin-left: 50px;
    opacity: 0;
  }

  .slide-fade-6-enter-active {
    transition: all 1.75s ease;
  }
  .slide-fade-6-leave-active {
    transition: all 1.75s;
  }
  .slide-fade-6-enter, .slide-fade-6-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    margin-left: 50px;
    opacity: 0;
  }

  .slide-fade-7-enter-active {
    transition: all 1.75s ease;
  }
  .slide-fade-7-leave-active {
    transition: all 1.75s;
  }
  .slide-fade-7-enter, .slide-fade-7-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/accueil/Slide2.vue